__turbopack_context__.v({
  "calculator-input-row": "pAUHNG_calculator-input-row",
  "calculator-usage-input": "pAUHNG_calculator-usage-input",
  "calculator-usage-input-error": "pAUHNG_calculator-usage-input-error",
  "modal-content": "pAUHNG_modal-content",
  "placeholder": "pAUHNG_placeholder",
});
